interface ValidationGroup {
    Message: string;
    Items: ValidationConfig;
}

type ValidationFunction = (item: any) => string | string[] | null | undefined;

type ValidationRule = string | ValidationGroup | ValidationFunction;

interface ValidationConfig {
    [key: string]: ValidationRule;
}

const validation: { [docType: string]: ValidationConfig } = {
        "invoice": {
            "InvoiceTotal": "missing invoice total",
            "InvoiceNumber": "missing invoice number",
            "PartnerPO": "missing PO number" ,
            "InvoiceLines": {
                Message: "missing line item information",
                Items: {
                    "Quantity": "missing quantity",
                    "Price": "missing price",
                    "ItemIdentifier": {
                        Message: "missing item identification",
                        Items: {
                            "SupplierSKU": "missing supplier SKU"
                        }
                    }
                }
            }
        },
        "order": {
            "PartnerPO": "missing PO number",
            "OrderLines": {
                Message: "missing line item information",
                Items: {
                    "Quantity": "missing quantity",
                    "Price": "missing price",
                    "ItemIdentifier": {
                        Message: "missing item identification",
                        Items: {
                            "SupplierSKU": "missing supplier SKU"
                        }
                    }
                }
            },
            "ShipToAddress": {
                Message: "missing shipping address",
                Items: {
                    "Address1": "missing shipping address line 1",
                    "City": "missing shipping address city",
                    "State": "missing shipping address state",
                    "Zip": "missing shipping address ZIP code",
                }
            }
        },
        "shipment": {
            "PartnerPO": "missing PO number",
            "ShipmentLines": {
                Message: "missing line item information",
                Items: {
                    "Validate": function(item) {
                        if(!item || item.Quantity){
                            return null;
                        }
                        if(item.ShipmentInfos && item.ShipmentInfos.filter(r => r.Qty > 0).length > 0){
                            return null;
                        }
                        return "missing quantity";
                    },
                    "ItemIdentifier": {
                        Message: "missing item identification",
                        Items: {
                            "SupplierSKU": "missing supplier SKU"
                        }
                    }
                }
            }
        },
        "acknowledgement": {
            "PartnerPO": "missing PO number",
            "AckLines": {
                Message: "missing line item information",
                Items: {
                    "Quantity": "missing quantity",
                    "ItemIdentifier": {
                        Message: "missing item identification",
                        Items: {
                            "SupplierSKU": "missing supplier SKU"
                        }
                    }
                }
            }
        },
        "return": {
            "PartnerPO": "missing PO number",
            "ReturnLines": {
                Message: "missing line item information",
                Items: {
                    "Quantity": "missing quantity",
                    "ItemIdentifier": {
                        Message: "missing item identification",
                        Items: {
                            "SupplierSKU": "missing supplier SKU"
                        }
                    }
                }
            }
        }
};
const getValidationWarnings = (docType: string, doc: any): string[] => {
    docType = docType.toLowerCase();
    var ret: string[] = [];
    var config = validation[docType];
    if(!config){
        return ret;
    }
    ret = getSpecificWarnings(doc, config);
    return ret.filter((value, index) => ret.indexOf(value) === index);
}
const getSpecificWarnings = (obj: any, config: ValidationConfig): string[] => {
    var ret: string[] = [];
    Object.keys(config).forEach(key => {
        var rule: any = config[key];
        if(key === "Validate"){
            var results = rule(obj);
            if(results){
                if(Array.isArray(results)){
                    ret = ret.concat(results);
                } else {
                    ret.push(results);
                }
            }
        }else{
            if(obj[key]){
                if(Array.isArray(obj[key]) && rule.Items){
                    obj[key].forEach((o: any) => {
                        var itemWarnings = getSpecificWarnings(o, rule.Items);
                        ret = ret.concat(itemWarnings);
                    });
                } else if (!Array.isArray(obj[key]) && rule.Items){
                    ret = ret.concat(getSpecificWarnings(obj[key], rule.Items));
                }
            }else{
                ret.push(typeof rule === "string" ? rule : rule.Message);
            }
        }
    });
    return ret;
}

export { getValidationWarnings };
